/** Envios ao cliente (guias e documentos: por onde, para quem, quem abriu) e o histórico de e-mails do sistema, como o cliente recebeu. */
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ListaEmails } from '../telas/emails/lista';
import { ListaEnvios } from '../telas/envios/lista';
import { Sec, Tabs } from '../ui/layout';

const Busca = z.object({ aba: z.enum(['envios', 'emails']).optional(), situacao: z.string().optional(), semAbertura: z.boolean().optional(), /** fatia 2c: só os envios que esperam a mensagem do WhatsApp */ whatsapp: z.boolean().optional(), /** fatia 2c: só os envios com item que não chegou a ninguém */ semDestinatario: z.boolean().optional() });
export const Route = createFileRoute('/_app/emails')({ validateSearch: Busca, component: Emails });

function Emails() {
  const s = Route.useSearch();
  const nav = Route.useNavigate();
  const aba = s.aba ?? 'envios';
  return (
    <>
      <div className="topbar"><div><h1>Envios e e-mails</h1><div className="sub">o que foi ao cliente — guias e documentos (por e-mail, WhatsApp, ZIP ou só portal) e todo e-mail que o sistema mandou — e como cada um saiu</div></div></div>
      <div className="conteudo">
        <Tabs valor={aba} onChange={(a) => void nav({ search: { aba: a } })} itens={[{ id: 'envios', rotulo: 'Envios ao cliente' }, { id: 'emails', rotulo: 'E-mails' }]} />
        {aba === 'envios'
          ? <Sec titulo="Envios ao cliente" sub="guias e documentos que foram ao cliente: clique num envio para ver os itens, quem recebeu e quem abriu"><ListaEnvios situacaoInicial={s.situacao} semAberturaInicial={s.semAbertura} whatsappInicial={s.whatsapp} semDestinatarioInicial={s.semDestinatario} /></Sec>
          : <Sec titulo="Histórico de e-mails" sub="clique numa linha para ver o e-mail exatamente como foi enviado"><ListaEmails situacaoInicial={s.situacao} /></Sec>}
      </div>
    </>
  );
}
